export var removeEventListener = function (type, handler, el, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    el.removeEventListener(type, handler, useCapture);
};
